webpackJsonp([35783957827783],{

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic02.7a91f05f.jpg";

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic03.68cd4e8a.jpg";

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic04.8055cb03.jpg";

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic11.616f5381.jpg";

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic15.dc1739c9.jpg";

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Banner = function Banner(props) {
	    return _react2.default.createElement(
	        "section",
	        { id: "banner", className: "major" },
	        _react2.default.createElement(
	            "div",
	            { className: "inner" },
	            _react2.default.createElement(
	                "header",
	                { className: "major" },
	                _react2.default.createElement(
	                    "h1",
	                    null,
	                    "The Rana Plaza Arrangement"
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "content" },
	                _react2.default.createElement(
	                    "h3",
	                    null,
	                    "Providing payments for losses suffered by the victims of Rana Plaza"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    null,
	                    "On April 24th 2013, 1134 people were killed and hundreds were injured when the Rana Plaza building in Savar, Bangladesh collapsed. "
	                ),
	                _react2.default.createElement(
	                    "p",
	                    null,
	                    "The Rana Plaza Arrangement was a ground-breaking initiative that would deliver loss of income payments to those families impacted by the Rana Plaza disaster. "
	                ),
	                _react2.default.createElement(
	                    "ul",
	                    { className: "actions" },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            "a",
	                            { href: "#one", className: "button next scrolly" },
	                            "Learn More"
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Banner;
	module.exports = exports["default"];

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(25);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Banner = __webpack_require__(209);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _pic = __webpack_require__(132);
	
	var _pic2 = _interopRequireDefault(_pic);
	
	var _pic3 = __webpack_require__(513);
	
	var _pic4 = _interopRequireDefault(_pic3);
	
	var _pic5 = __webpack_require__(514);
	
	var _pic6 = _interopRequireDefault(_pic5);
	
	var _pic7 = __webpack_require__(515);
	
	var _pic8 = _interopRequireDefault(_pic7);
	
	var _pic9 = __webpack_require__(522);
	
	var _pic10 = _interopRequireDefault(_pic9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomeIndex = function (_React$Component) {
	    _inherits(HomeIndex, _React$Component);
	
	    function HomeIndex() {
	        _classCallCheck(this, HomeIndex);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    HomeIndex.prototype.render = function render() {
	        var siteTitle = this.props.data.site.siteMetadata.title;
	        var siteDescription = this.props.data.site.siteMetadata.description;
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _reactHelmet2.default,
	                null,
	                _react2.default.createElement(
	                    'title',
	                    null,
	                    siteTitle
	                ),
	                _react2.default.createElement('meta', { name: 'description', content: siteDescription })
	            ),
	            _react2.default.createElement(_Banner2.default, null),
	            _react2.default.createElement(
	                'div',
	                { id: 'main' },
	                _react2.default.createElement(
	                    'section',
	                    { id: 'one', className: 'tiles' },
	                    _react2.default.createElement(
	                        'article',
	                        { style: { backgroundImage: 'url(' + _pic2.default + ')' } },
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                'Introduction'
	                            ),
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'History and necessity'
	                            )
	                        ),
	                        _react2.default.createElement(_gatsbyLink2.default, { to: '/intro', className: 'link primary' })
	                    ),
	                    _react2.default.createElement(
	                        'article',
	                        { style: { backgroundImage: 'url(' + _pic4.default + ')' } },
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                'The Arrangement'
	                            ),
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Who created it, and how it was run.'
	                            )
	                        ),
	                        _react2.default.createElement(_gatsbyLink2.default, { to: '/about', className: 'link primary' })
	                    ),
	                    _react2.default.createElement(
	                        'article',
	                        { style: { backgroundImage: 'url(' + _pic10.default + ')' } },
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                'Activities'
	                            ),
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Timeline & Donors'
	                            )
	                        ),
	                        _react2.default.createElement(_gatsbyLink2.default, { to: '/activities', className: 'link primary' })
	                    ),
	                    _react2.default.createElement(
	                        'article',
	                        { style: { backgroundImage: 'url(' + _pic8.default + ')' } },
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                'Claims & payments'
	                            ),
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Methodology, calculations, and health care benefits'
	                            )
	                        ),
	                        _react2.default.createElement(_gatsbyLink2.default, { to: '/claims', className: 'link primary' })
	                    )
	                )
	            )
	        );
	    };
	
	    return HomeIndex;
	}(_react2.default.Component);
	
	exports.default = HomeIndex;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-913cd9361791f4ea492b.js